/**
 * Helpers for enrollment media attachments (identity docs, cards, etc.).
 */

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i;
const PDF_EXT = /\.pdf(\?|$)/i;

/** Resolve a FileField /media path against the API host when needed. */
export function resolveMediaUrl(url) {
  if (!url) return null;
  const raw = String(url).trim();
  if (!raw) return null;
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw;

  const path = raw.startsWith("/") ? raw : `/${raw}`;
  const api = process.env.REACT_APP_API_URL || "/api";

  if (/^https?:\/\//i.test(api)) {
    try {
      const origin = new URL(api).origin;
      return `${origin}${path}`;
    } catch (e) {
      return path;
    }
  }

  // Same-origin (nginx serves /media) or relative fallback
  return path;
}

export function getMediaKind(url) {
  if (!url) return "other";
  const cleaned = String(url).split("?")[0].toLowerCase();
  if (IMAGE_EXT.test(cleaned)) return "image";
  if (PDF_EXT.test(cleaned)) return "pdf";
  // Django storage names without extension are rare; treat unknown as other
  return "other";
}

export function mediaFileName(url) {
  if (!url) return "";
  try {
    const path = String(url).split("?")[0];
    const parts = path.split("/");
    return decodeURIComponent(parts[parts.length - 1] || path);
  } catch (e) {
    return String(url);
  }
}
